import {
  STOCK_EQUIPMENT_ERROR,
  STOCK_EQUIPMENT_LOADED,
  STOCK_EQUIPMENT_LOADING,
  STOCK_EQUIPMENT_REFRESH_ERROR,
} from '../constants/AppConstants';
import { ApiDate, StockEquipment } from '../model/model';
import { AnyAction } from 'redux';

type StockEquipmentsState = {
  stockOutletCode: string | null;
  stockOutletName: string | null;
  pausedInventoryDate: ApiDate;
  stockEquipments: StockEquipment[];
  loading: boolean;
  error: any;
};

const initialState: StockEquipmentsState = {
  stockOutletCode: null,
  stockOutletName: null,
  pausedInventoryDate: null,
  stockEquipments: [],
  loading: false,
  error: null,
};

export default function (state = initialState, action: AnyAction): StockEquipmentsState {
  switch (action.type) {
    case STOCK_EQUIPMENT_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
        stockOutletCode: action.stockOutletCode,
        stockOutletName: null,
        pausedInventoryDate: null,
        stockEquipments: [],
      };
    case STOCK_EQUIPMENT_LOADED:
      return {
        ...state,
        loading: false,
        error: null,
        stockOutletCode: action.stockOutletCode,
        stockOutletName: action.stockOutletName,
        pausedInventoryDate: action.pausedInventoryDate,
        stockEquipments: action.stockEquipments,
      };
    case STOCK_EQUIPMENT_ERROR:
    case STOCK_EQUIPMENT_REFRESH_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}
